export default {
  en: {
    subgroups: 'Subgroups',
  },
};
